export const menu = [
  { path: '/dashboard', label: '首页看板', icon: 'el-icon-data-analysis' },
  { path: '/products', label: '产品管理', icon: 'el-icon-goods' },
  { path: '/categories', label: '分类管理', icon: 'el-icon-menu' },
  { path: '/codes', label: '防伪码管理', icon: 'el-icon-tickets' },
  { path: '/scan-records', label: '扫码记录', icon: 'el-icon-view' },
  { path: '/statistics', label: '数据统计', icon: 'el-icon-pie-chart' },
  { path: '/activities', label: '活动管理', icon: 'el-icon-present' },
  { path: '/users', label: '用户管理', icon: 'el-icon-user' },
  { path: '/cms', label: '系统配置', icon: 'el-icon-setting' }
]

export function titleByPath(path) {
  const item = menu.find(entry => entry.path === path)
  return item ? item.label : '管理后台'
}
